import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { useTranslation } from 'react-i18next';

// ui
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import InfoIcon from '@material-ui/icons/Info';
import IconButton from '@material-ui/core/IconButton';

// style
import { StormIcon } from '../../../assets/svg/Icon';
import { styles, StyledBadge } from '../style';

const useStyles = makeStyles(styles);
const initPath = `/${process.env.REACT_APP_PATH}`;

export default function Storm(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const { datas, mobilemode, handleOpenLegend } = props;

  function setColorBoxFormLegend(data) {
    const stormlasted = data.storm_data.reduce(
      (a, b) => (new Date(a.storm_datetime) > new Date(b.storm_datetime) ? a : b),
    );
    const wind = stormlasted.storm_wind;
    const style = {
      color: 'white',
      textShadow: '1px 1px 3px #000',
      background: '#ff0000',
    };
    if (wind < 34) {
      style.background = '#62cafa';
    } else if (wind >= 34 && wind <= 63) {
      style.background = '#7cfa4c';
    } else if (wind >= 64 && wind <= 82) {
      style.background = '#fffe54';
    } else if (wind >= 83 && wind <= 95) {
      style.background = '#f6cd46';
    } else if (wind >= 96 && wind <= 113) {
      style.background = '#eb702d';
    } else if (wind >= 114 && wind <= 135) {
      style.background = '#e73323';
    } else if (wind >= 135) {
      style.background = '#b92cc5';
    }
    return style;
  }

  console.log(datas);

  return (
    <Box className={mobilemode ? classes.boxViewMobile : classes.boxViewStorm}>
      <Box display="flex" justifyContent="flex-end">
        <Box>
          <Box display="flex" alignItems="center">
            <Box display="flex" className={classes.shapeCircle} alignItems="center" justifyContent="center">
              <StyledBadge badgeContent={datas.length} overlap="circular" color="secondary">
                <StormIcon style={{ color: 'white' }} />
              </StyledBadge>
            </Box>
            <Box id="dialog_storm" display="flex" alignItems="center">
              <Box pl={1}>
                <IconButton id="legend-storm" className={classes.btn} onClick={handleOpenLegend(t('เกณฑ์พายุ'), 'storm')}>
                  <InfoIcon style={{ fontSize: 13, color: '#777' }} />
                </IconButton>
              </Box>
              <Box p={1}>
                <Link id="navigate_storm" to={`${initPath}storm`}>
                  <Typography className={classes.titleBox}>
                    {t('พายุ')}
                  </Typography>
                </Link>
              </Box>
            </Box>
          </Box>
          <Box>
            <Grid container justifyContent="flex-start" spacing={1} className={classes.contentBox}>
              <Grid item>
                {datas.length === 0
                  && (
                    <Box
                      id="list_name_storm"
                      className={`${classes.listsBox}`}
                      style={{ backgroundColor: '#FFFFFF50', fontWeight: 'bold' }}
                    >
                      {t('ไม่มีพายุ')}
                    </Box>
                  )}

                {datas.map((d) => (
                  // <Box id="list_name_storm" key={d.storm_name} className={`${classes.listsBox} ${classes.red}`}>
                  <Box id="list_name_storm" key={d.storm_name} className={`${classes.listsBox}`} style={setColorBoxFormLegend(d)}>
                    {d.storm_name}
                  </Box>
                ))}
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
Storm.defaultProps = {
  mobilemode: false,
};

Storm.propTypes = {
  datas: PropTypes.instanceOf(Array).isRequired,
  mobilemode: PropTypes.bool,
  handleOpenLegend: PropTypes.func.isRequired,
};
